import { Tabs } from 'antd';
import { PageHeader } from '../../components/PageHeader';
import { OwnersPage } from '../owners/OwnersPage';
import { TrailersPage } from '../trailers/TrailersPage';
import { TrucksPage } from '../trucks/TrucksPage';

/**
 * The Fleet nav section's landing page: trucks, trailers and owners are all
 * real screens now, so `/fleet` picks between them with tabs rather than
 * favouring one, the same shape `ReferenceDataPage` uses for its own catalogues.
 */
export function FleetPage() {
  return (
    <>
      <PageHeader eyebrow="Assets" title="Fleet" description="Trucks, trailers, owners and everything that keeps them on the road." />
      <Tabs
        items={[
          { key: 'trucks', label: 'Trucks', children: <TrucksPage /> },
          { key: 'trailers', label: 'Trailers', children: <TrailersPage /> },
          { key: 'owners', label: 'Owners', children: <OwnersPage /> },
        ]}
      />
    </>
  );
}
